export default __webpack_public_path__ + "static/thumbnailBg-910d4469b424fa487f5b9b0f7fbe5a05.png";